import React from 'react';
import Text from '../../../Text';
import * as Styles from './styles';
import { MapPin } from '@olxbr/ds-icons';
export const Location = _ref => {
  let {
    mode,
    children,
    date,
    showLocationMapPin
  } = _ref;
  return React.createElement(Styles.Location, {
    mode: mode,
    className: mode
  }, !!children && React.createElement(Styles.LocationDateContainer, null, showLocationMapPin && React.createElement(MapPin, {
    size: 16
  }), React.createElement(Text.Caption, {
    tag: "p"
  }, children)), !!date && mode === 'horizontal' && !!children ? React.createElement(Styles.Separator, {
    className: mode,
    "aria-hidden": true
  }, "\u00A0|\u00A0") : null, !!date && React.createElement(Styles.LocationDateContainer, null, React.createElement(Text.Caption, {
    className: "".concat(mode, " date"),
    tag: "p",
    "data-testid": "ds-adcard-date"
  }, date)));
};